import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineRentDeleteApi extends BaseClient {
  public doMachineRentDelete (id: string) {
    const path: string = '/v1/machine-rents/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new MachineRentDeleteApi()
